export default {
  state: {
    schedule: {
      show: false,
      loading: false,
      loadingMsg: '',
      accepted: false,
      rsvp: [],
      pkg: [],
      driverData: {
        id: 0,
        name: ''
      },
      error: ''
    },
    currentTable: 0
  },
  mutations: {
    setScheduleShow (state, value) { state.schedule.show = value },
    setScheduleLoading (state, value) { state.schedule.loading = value },
    setScheduleLoadingMsg (state, value) { state.schedule.loadingMsg = value },
    setScheduleAccepted (state, value) { state.schedule.accepted = value },
    setScheduleRsvp (state, value) { state.schedule.rsvp = value },
    setSchedulePkg (state, value) { state.schedule.pkg = value },
    setScheduleDriverData (state, value) { state.schedule.driverData = value },
    setScheduleError (state, value) { state.schedule.error = value },
    setCurrentTable (state, value) { state.currentTable = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/dispatch/dispatch-schedule.js